import { useState } from "react";
import Card from "@/components/base/Card";
import Button from "@/components/base/Button";
import Input from "@/components/base/Input";
import Badge from "@/components/base/Badge";

export default function ConsultaHistorialPage() {
  const [messages, setMessages] = useState([
    {
      remitente: "Tú",
      rol: "Usuario",
      texto: "¿Cuál es el plazo legal para responder a un oficio del tribunal de familia?",
      fecha: "2026-06-08",
      mio: true
    },
    {
      remitente: "Ezer IA",
      rol: "IA Normativa",
      texto: "Generalmente los tribunales de familia fijan un plazo de 10 o 15 días hábiles a partir de la notificación del oficio, salvo que el oficio indique expresamente que es urgente o fije una fecha de audiencia (en cuyo caso se debe responder antes de dicha audiencia). Te recomiendo revisar el RIT correspondiente.",
      fecha: "2026-06-08",
      mio: false
    }
  ]);
  const [input, setInput] = useState("");

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim()) return;
    const nuevo = {
      remitente: "Tú",
      rol: "Profesor Jefe",
      texto: input,
      fecha: new Date().toLocaleTimeString().slice(0,5),
      mio: true
    };
    setMessages([...messages, nuevo]);
    setInput("");
  };

  return (
    <div className="p-4 md:p-6 space-y-4 animate-fade-in-up h-[calc(100vh-130px)] flex flex-col">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Historial de Consultas a la IA</h1>
        <p className="text-sm text-foreground-500 mt-0.5">Revisa tus conversaciones históricas, dudas resueltas sobre normativas chilenas y reglamentos escolares.</p>
      </div>

      <Card className="flex-1 flex flex-col p-0 overflow-hidden min-h-[350px]">
        {/* Chat Feed */}
        <div className="flex-1 p-4 overflow-y-auto space-y-4 bg-background-50/20">
          {messages.map((m, idx) => (
            <div key={idx} className={`flex ${m.mio ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[70%] rounded-2xl p-3.5 shadow-sm border ${
                m.mio
                  ? "bg-primary-500 text-white border-primary-600 rounded-tr-none"
                  : "bg-white text-foreground-800 border-background-200 rounded-tl-none"
              }`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs font-bold ${m.mio ? "text-white" : "text-foreground-900"}`}>{m.remitente}</span>
                  <Badge variant={m.mio ? "neutral" : "accent"} className="text-3xs scale-90 px-1 py-0">{m.rol}</Badge>
                </div>
                <p className="text-sm whitespace-pre-wrap leading-relaxed">{m.texto}</p>
                <div className={`text-3xs mt-1.5 text-right ${m.mio ? "text-white/70" : "text-foreground-400"}`}>{m.fecha}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Input Bar */}
        <form onSubmit={handleSend} className="p-3 border-t border-background-200 bg-white flex gap-2">
          <Input
            placeholder="Escribe tu mensaje aquí..."
            value={input}
            onChange={e => setInput(e.target.value)}
            className="flex-1"
            fullWidth={false}
          />
          <Button type="submit" className="bg-primary-500 text-white px-5 hover:bg-primary-600 cursor-pointer">
            Enviar <i className="ri-send-plane-fill ml-1" />
          </Button>
        </form>
      </Card>
    </div>
  );
}
